/* eslint-disable jira/naming/disallow-filenames */
// eslint-disable-next-line jira/filename-case
import React, { useCallback } from 'react';
import AsyncChangeOwnerModal from '@jira/global-pages__directories-filters-directory-v2-change-owner-filter-modal/src/async.tsx';

type Props = {
	isOpen: boolean;
	filterId: string;
	onRefetch: (options: { onComplete: () => void }) => void;
	onClose: () => void;
};

export const ChangeOwnerModal = ({
	isOpen,
	filterId,
	onRefetch,
	onClose,
}: Props): false | React.JSX.Element => {
	const onSuccess = useCallback(() => {
		onRefetch({ onComplete: () => undefined });
		onClose();
	}, [onRefetch, onClose]);

	return (
		isOpen && (
			<AsyncChangeOwnerModal
				id={filterId}
				onInitiateSuccess={() => undefined}
				onSuccess={onSuccess}
				onCancel={onClose}
				onInitiateFailed={() => undefined}
			/>
		)
	);
};
